import {ChatHandoffFlowRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';
import VIDABOO_CONSTANTS from '../../config/consts';

var service = {};

service.handoffSelectionFromCustomer = async (
  objectType,
  objectId,
  chatHandoffFlowId,
  selectedAction,
) => {
  const requestObj = {
    endpoint: 'customer/selection',
    endpointParam: chatHandoffFlowId,
  };
  const requestObj2 = {
    objectId,
    objectType,
    chatHandoffFlowId,
    selectedAction,
  };

  if (objectType === VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR) {
    requestObj2.token = storageService.getItem('token');
  }

  const response = await ChatHandoffFlowRestService.update(
    requestObj,
    requestObj2,
  );
  utilsService.logApiResponse('handoffSelectionFromCustomer', response.data);
  return response.data;
};

service.getChatHandoffByChatHandoffFlowId = async (
  objectType,
  objectId,
  chatHandoffFlowId,
) => {
  const requestObj = {
    endpoint: 'chatHandoffFlowId',
    endpointParam: chatHandoffFlowId,
  };
  const requestObj2 = {
    objectId,
    objectType,
    chatHandoffFlowId,
  };

  if (objectType === VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR) {
    requestObj2.token = storageService.getItem('token');
  }

  const response = await ChatHandoffFlowRestService.get(
    requestObj,
    requestObj2,
  );
  utilsService.logApiResponse(
    'getChatHandoffByChatHandoffFlowId',
    response.data,
  );
  return response.data;
};

service.failureHotHandoff = async (objectType, objectId, chatHandoffFlowId) => {
  const requestObj = {
    endpoint: 'failure',
    endpointParam: chatHandoffFlowId,
  };
  const requestObj2 = {
    objectId,
    objectType,
  };

  if (objectType === VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR) {
    requestObj2.token = storageService.getItem('token');
  }

  const response = await ChatHandoffFlowRestService.update(
    requestObj,
    requestObj2,
  );
  utilsService.logApiResponse('failureHotHandoff', response.data);
  return response.data;
};

const chatHandoffService = {...service};
export default chatHandoffService;
